export default __webpack_public_path__ + "static/media/27-seethrough.6405d851.png";